export default __webpack_public_path__ + "static/media/profile_15.a427512d.jpg";